/**
 * All known permissions in our JWTs - I pulled them from the identity-service permissions model file. There
 * could be more of them floating around out there for all I know.
 */
export type Permission = (typeof Permissions)[keyof typeof Permissions];
export const Permissions = {
  SUPER_ADMIN: "super_admin",
  CRM_ADMIN: "crm_admin",
  CRM_DEPARTMENT_ADMIN: "crm_department_admin",
  CE_ADMIN: "ce_admin",
  MOBILE_CONFIGURATION: "mobile_configuration",
  MANAGE_EMPLOYEES: "manage_employees",
  MANAGE_SUPER_ADMINS: "manage_super_admins",
  MANAGE_COMMUNICATIONS: "manage_communications",
  MANAGE_PERMITS: "manage_permits",
  REVIEW_PERMITS: "review_permits",
  MANAGE_INSPECTIONS: "manage_inspections",
  REVIEW_INSPECTIONS: "review_inspections",
} as const;
